"use strict";

var _interopRequireDefault = require("/Users/sophiechou/Desktop/whenyoung/\u5609\u5584\u51CF\u707E\u793E\u533A/admin-web/node_modules/.pnpm/@babel+runtime@7.21.0/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/Users/sophiechou/Desktop/whenyoung/\u5609\u5584\u51CF\u707E\u793E\u533A/admin-web/node_modules/.pnpm/@babel+runtime@7.21.0/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _default = {
  route: {
    dashboard: '系统主页',
    profile: '个人中心'
  },
  navbar: {
    setting: '系统设置',
    logOut: '退出登录',
    profile: '个人中心',
    theme: '换肤',
    size: '布局大小',
    deleteCache: '清除缓存'
  },
  login: {
    title: '应急仓库管理系统',
    logIn: '立即登录',
    tenant: '仓库',
    username: '账号',
    password: '密码',
    code: '验证码',
    ortherLoginType: '其他登录方式',
    chooseToSignIn: '选择以下账号登录：',
    type: {
      up: '账号密码登录',
      social: '第三方账号登录'
    }
  },
  editPhone: {
    phone: '手机号',
    submitBtn: "立即绑定"
  },
  documentation: {
    documentation: '项目文档',
    github: '项目地址'
  },
  table: {
    essentialInfo: {
      id: 'ID',
      essentialName: '要素名称',
      essentialType: '要素类型 #EssentialType{IMAGE_TEXT:图文;INTERFACE_DATA:接口;}',
      essentialContent: '图文要素文字内容',
      interfaceType: '接口类型 #InterfaceType{INTERFACE_WAREHOUSE:仓库;INTERFACE_MATERIAL:物资;INTERFACE_TEAM:队伍;INTERFACE_SHELTER:队伍;}',
      essentialPicId: '图片文件id',
      dataStatus: '状态 #DataStatus{DRAFT:草稿;NORMAL:正常;DELETED:已删除;}'
    },
    jsKeyPointInfo: {
      id: 'ID',
      deviceName: '设备名称',
      deviceSn: '设备唯一标识',
      longitude: '经度',
      latitude: '纬度',
      coordinateType: '坐标类型 #CoordinateType{WGS84:天地图坐标系(地球坐标系);BD09:百度坐标系;GCJ02:火星坐标系;}',
      capacity: '能力集',
      resourceType: '点位类型',
      cascade: '是否级联',
      address: '安装地址',
      siteNo: '场所编码',
      siteName: '场所名称',
      areaId: '区域ID',
      areaName: '区域名称',
      major: '是否重要点位  0否  1是'
    },
    jsTeam: {
      id: 'ID',
      name: '队伍名称',
      level: '队伍等级 #@InjectionField(api = DICTIONARY_ITEM_CLASS, method = DICTIONARY_ITEM_METHOD, dictType = DictionaryType.COMMON_LEVEL) RemoteData<String,String>',
      type: '队伍类型',
      address: '队伍详细地址',
      longitude: '队伍详细位置（经度）',
      latitude: '队伍详细位置（维度）',
      coordinateType: '坐标类型 #CoordinateType{WGS84:天地图坐标系(地球坐标系);BD09:百度坐标系;GCJ02:火星坐标系;}',
      managerName: '队伍负责人姓名',
      managerPhone: '队伍负责人电话',
      capacity: '队伍救援能力（救援类型）',
      totalCount: '队伍人数'
    },
    applyUserRecord: {
      id: 'ID',
      zzdAccountId: '浙政钉账户id',
      name: '申请人姓名',
      identityCard: '证件号',
      mobileLastFour: '手机号后四位',
      employeeCode: '员工code',
      departmentName: '浙政钉组织名称',
      organizationCode: '浙政钉组织code',
      auditStatus: '审核状态 #AuditStatus{WAIT:待审核;REFUSE:拒绝;PASS:审核通过;}',
      auditTime: '审核时间',
      auditUser: '审核人',
      dataStatus: '状态 #DataStatus{DRAFT:草稿;NORMAL:正常;DELETED:已删除;}'
    },
    cUserZzdInfo: {
      id: 'ID',
      userId: '用户id',
      openid: '浙政钉openid',
      account: '账号名',
      accountId: '账号id',
      clientId: '应用名',
      employeeCode: '租户下人员编码',
      lastName: '姓名',
      namespace: '账号类型',
      nickNameCn: '昵称',
      realmId: '租户id',
      realmName: '租户名称',
      tenantUserId: '租户+用户唯一标识',
      zzdDeptName: '浙政钉部门名称',
      remark: '用户备注'
    },
    warnListenCfg: {
      id: 'ID',
      name: '单位名称',
      warnClassifyId: '预警类型',
      keywords: '关键词(用逗号分隔)',
      remark: '备注',
      dataStatus: '状态 #DataStatus{DRAFT:草稿;NORMAL:正常;DELETED:已删除;}'
    },
    warnInfo: {
      id: 'ID',
      warnContent: '预警内容',
      customizeContent: '修改后自定义内容',
      warnListenId: '来源id',
      receiveTime: '接收时间',
      publishStatus: '预警发布状态 #PublishStatus{UNRELEASED:未发布;RELEASED:已发布}',
      publishTime: '发布时间'
    },
    msgUserRecord: {
      id: 'ID',
      zzdBizType: '业务对象类型 #ZzdBizType{WARN:预警;INSTRUCT:指令;ANSWER:叫应;}',
      zzdBizId: '业务对象id',
      receiveCfgId: '接受对象id',
      userId: '接收人id',
      departmentId: '部门id',
      roleId: '角色id',
      sendStatus: '发送状态 #FinishStatus{SUCCESS:已接收;FAILED:已完成;}',
      snedTime: '发送时间',
      finishStatus: '完成状态 #FinishStatus{NO_RECEIVE:未接收;RECEIVED:已接收;FINISHED:已完成;}',
      userResponseTime: '用户响应时间',
      finishTime: '完成时间',
      dataStatus: '状态 #DataStatus{DRAFT:草稿;NORMAL:正常;DELETED:已删除;}'
    },
    instructInfo: {
      id: 'ID',
      instructContent: '指令内容',
      instructType: '指令类型 #InstructType{MANUAL:手动;AUTOMATIC:自动}',
      publishTime: '发布时间（类型为自动时，到点自动发送）',
      dataStatus: '状态 #DataStatus{DRAFT:草稿;NORMAL:正常;DELETED:已删除;}'
    },
    emergencyPlanStrategy: {
      id: 'ID',
      name: '名称',
      strategyDescribe: '描述',
      openStatus: '开启状态 #OpenStatus{OPEN:开启;CLOSE:关闭;}',
      openCount: '开启次数',
      dataStatus: '状态 #DataStatus{DRAFT:草稿;NORMAL:正常;DELETED:已删除;}'
    },
    autoInstructCfg: {
      id: 'ID',
      emergencyPlanId: '预案id',
      segmentId: '预案环节id',
      instructContent: '指令内容',
      dataStatus: '状态 #DataStatus{DRAFT:草稿;NORMAL:正常;DELETED:已删除;}'
    },
    blockList: {
      id: 'ID',
      ip: '阻止访问ip',
      requestUri: '请求URI',
      requestMethod: '请求方法',
      limitStart: '限制时间起',
      limitEnd: '限制时间止',
      state: '状态'
    },
    rateLimiter: {
      id: 'ID',
      count: '次数',
      requestUri: '请求URI',
      requestMethod: '请求方法',
      limitStart: '限制时间起',
      limitEnd: '限制时间止',
      state: '状态',
      intervalSec: '时间窗口'
    },
    tenant: {
      code: '仓库编码',
      name: '仓库名称',
      type: '类型',
      connectType: '连接类型',
      status: '状态',
      readonly: '内置',
      duty: '责任人',
      expirationTime: '有效期',
      logo: 'logo',
      describe: '仓库简介',
      passwordExpire: '密码有效期',
      isMultipleLogin: '是否允许多地登录',
      passwordErrorNum: '密码输错次数',
      passwordErrorLockTime: '账号锁定时间'
    },
    datasourceConfig: {
      id: 'ID',
      name: '名称',
      poolName: '数据源名',
      username: '账号',
      password: '密码',
      url: '链接',
      driverClassName: '驱动'
    },
    online: {
      userId: "用户id",
      loginIp: "登录IP",
      location: "登录地点",
      clientId: "客户端Key",
      token: "token",
      name: "姓名",
      expireTime: "过期时间",
      account: "账号",
      expireMillis: "有效期",
      loginTime: "登录时间"
    },
    user: {
      account: '账号',
      name: '姓名',
      password: '密码',
      orgId: '组织',
      stationId: '岗位',
      email: '邮箱',
      sex: '性别',
      state: '状态',
      mobile: '电话',
      avatar: '头像',
      workDescribe: '个人描述',
      passwordErrorLastTime: '最后一次输错密码时间',
      passwordErrorNum: '密码错误次数',
      passwordExpireTime: '密码过期时间',
      lastLoginTime: '最后登录时间',
      nation: '民族',
      education: '学历',
      positionStatus: '职位状态',
      createTime: '创建时间',
      updateTime: '修改时间',
      oldPassword: '旧密码',
      newPassword: '新密码',
      confirmPassword: '确认密码',
      social: '第三方账号'
    },
    role: {
      code: '编码',
      name: '角色名称',
      describe: '角色描述',
      state: '状态',
      readonly: '内置',
      createTime: '创建时间',
      dsType: '数据范围',
      orgList: '组织',
      homeUrl: '首页地址'
    },
    menu: {
      id: 'ID',
      label: '名称',
      describe: '描述',
      code: '权限编码',
      isGeneral: '通用菜单',
      path: '路由URI',
      type: '类型',
      component: '组件',
      state: '状态',
      sortValue: '排序',
      parentId: '上级ID',
      icon: '图标',
      group: '分组',
      readonly: '内置'
    },
    resource: {
      code: '编码',
      name: '名称',
      describe: '描述'
    },
    org: {
      label: '部门名称',
      abbreviation: '简称',
      describe: '描述',
      parentId: '上级ID',
      type: '类型',
      sortValue: '排序',
      state: '状态'
    },
    station: {
      name: '岗位名称',
      describe: '描述',
      orgId: '组织',
      state: '状态'
    },
    optLog: {
      requestIp: 'IP',
      type: '类型',
      userName: '操作人',
      description: '操作描述',
      classPath: '类路径',
      actionMethod: '请求方法',
      requestUri: '请求地址',
      httpMethod: '请求类型',
      params: '方法参数',
      result: '返回值',
      exDesc: '异常详情信息',
      consumingTime: '消耗时间',
      startTime: '开始时间',
      finishTime: '完成时间',
      ua: '浏览器请求头'
    },
    loginLog: {
      userName: '姓名',
      account: '账号',
      requestIp: 'IP',
      description: '描述',
      loginDate: '登录时间',
      ua: '浏览器请求头',
      browser: '浏览器',
      browserVersion: '浏览器版本',
      operatingSystem: '操作系统',
      location: '地区'
    },
    attachment: {
      bizId: '业务ID',
      bizType: '业务类型',
      dataType: '数据类型',
      submittedFileName: '文件名',
      group: '组',
      path: '路径',
      relativePath: '相对路径',
      url: '访问链接',
      fileMd5: 'md5',
      contextType: '类型',
      filename: '唯一文件名',
      ext: '后缀',
      size: '大小',
      orgId: '组织',
      icon: '图标'
    },
    smsTemplate: {
      providerType: '类型',
      appId: '应用ID',
      appSecret: '应用密码',
      url: 'SMS服务域名',
      customCode: '自定义编码',
      name: '模板名称',
      content: '模板内容',
      templateParams: '模板参数',
      templateCode: '模板CODE',
      signName: '模板签名',
      templateDescribe: '模板描述'
    },
    smsTask: {
      templateId: '短信模板',
      status: '执行状态',
      sourceType: '来源类型',
      receiver: '接收者',
      topic: '主题',
      templateParams: '模板参数',
      sendTime: '发送时间',
      content: '发送内容',
      draft: '是否草稿'
    },
    smsSendStatus: {
      taskId: '任务',
      sendStatus: '发送状态',
      receiver: '接收者手机号',
      bizId: '发送回执',
      ext: '发送返回',
      code: '状态码',
      message: '状态码的描述',
      fee: '计费条数'
    },
    reservoir: {
      refresh: '刷新全部库房',
      serialNumber: '序号'
    },
    msg: {
      bizType: '业务类型',
      bizId: '业务ID',
      msgType: '消息类型',
      title: '标题',
      content: '内容',
      author: '作者',
      handlerUrl: '处理地址',
      handlerParams: '处理参数',
      isSingleHandle: '是否单人处理',
      isDelete: '是否删除',
      isRead: '状态',
      readTime: '读消息的时间'
    },
    application: {
      clientId: "clientId",
      clientSecret: "clientSecret",
      website: "官网",
      name: "应用名称",
      icon: "应用图标",
      appType: "类型",
      describe: "备注",
      state: "状态"
    },
    dictionary: {
      type: "类型",
      label: "类型标签",
      code: "编码",
      name: "名称",
      describe: "描述",
      state: "状态",
      sortValue: "排序",
      icon: "图标",
      cssStyle: "样式",
      cssClass: "类选择器",
      readonly: "内置"
    },
    area: {
      code: "编码",
      label: "名称",
      fullName: '全名',
      sortValue: '排序',
      longitude: '经度',
      latitude: '维度',
      level: "行政区级",
      parentCode: '父编码',
      parentId: '上级地区',
      source: '数据来源'
    },
    parameter: {
      key: "参数键",
      name: "参数名称",
      value: '参数值',
      describe: '描述',
      state: '状态',
      readonly: '内置'
    },
    gen: {
      config: {
        author: '作者名称',
        basePackage: '基础包名',
        entityPackage: 'entity包名',
        mapperPackage: 'mapper包名',
        mapperXmlPackage: 'mapperXml包名',
        servicePackage: 'service包名',
        serviceImplPackage: 'serviceImpl包名',
        controllerPackage: 'controller包名',
        isTrim: '是否去除表前缀',
        trimValue: '表前缀'
      },
      generate: {
        tableName: '表名',
        remark: '备注',
        dataRows: '数据量（行）',
        createTime: '创建时间',
        updateTime: '更新时间'
      }
    },
    activitiModel: {
      id: '模型主键',
      name: '模型名称',
      key: '模型标识',
      version: '版本',
      description: '模型描述',
      status: '发布状态',
      createTime: '创建时间',
      lastUpdateTime: '最后修改时间'
    },
    definitionModel: {
      id: '流程主键',
      tenantId: '仓库编号',
      name: '流程名称',
      deploymentName: '部署名称',
      key: '流程标识',
      version: '流程版本',
      suspendStateName: '状态',
      deploymentTime: '部署时间'
    },
    instantModel: {
      id: '主键',
      tenantCode: '仓库编号',
      name: '请假人员',
      type: '请假类型',
      isOver: '完成状态',
      suspendStateName: '激活状态',
      startTime: '开始时间',
      endTime: '结束时间'
    },
    instantReimbursementModel: {
      id: '主键',
      tenantId: '仓库编号',
      name: '报销人员',
      type: '报销类型',
      amount: '报销金额',
      isOver: '完成状态',
      suspendStateName: '激活状态',
      createTime: '申请时间'
    },
    ruTaskModel: {
      id: '任务主键',
      tenantId: '仓库编号',
      name: '当前任务名称',
      processDefinitionName: '流程名称',
      processDefinitionKey: '流程KEY',
      suspendStateName: '激活状态',
      reason: '请假原因',
      type: '请假类型',
      typeReimbursement: '报销类型',
      reasonReimbursement: '报销说明',
      startUser: '发起人',
      startTime: '发起时间',
      createTime: '申请时间'
    },
    ruTaskItemModel: {
      id: '事项主键',
      itemName: '事项名称',
      itemRemake: '事项备注',
      result: '事项结果',
      createdBy: '处理人',
      createTime: '处理时间'
    },
    waring: (0, _defineProperty2.default)({
      level: '等级',
      type: '预警类型'
    }, "type", '预警类型'),
    status: '状态',
    state: '状态',
    refresh: '刷新',
    operation: '操作',
    search: '搜索',
    reset: '重置',
    more: '更多',
    add: '添加',
    export: '导出',
    exportPreview: '导出预览',
    import: '导入',
    upload: '上传',
    download: '下载',
    templateDownload: '模板下载',
    delete: '删除',
    resetPassword: '密码重置',
    openInNewPage: '新页面打开',
    createTime: '创建时间',
    updateTime: '修改时间',
    keyword: '关键词',
    readonly: '内置',
    allType: '全部类型',
    allStatus: '全部状态',
    allLevel: '全部等级'
  },
  tagsView: {
    refresh: '刷新当前',
    close: '关闭当前',
    closeOthers: '关闭其它',
    closeAll: '关闭所有'
  },
  settings: {
    title: '系统布局配置',
    theme: '主题色',
    tagsView: '开启 Tags-View',
    fixedHeader: '固定 Header',
    sidebarLogo: '侧边栏 Logo',
    uniqueOpened: '只保持一个子菜单的展开'
  },
  system: {
    title: '应急救援指挥平台管理'
  },
  tips: {
    readonly: '系统数据，不能操作',
    systemError: '系统维护中，请稍微再试~',
    usernameShouldNotBeEmpty: '用户名不能为空',
    passwordShouldNotBeEmpty: '密码不能为空',
    switchLanguageSuccess: '切换语言成功',
    loginSuccess: '登录成功',
    loginFail: '登录失败',
    defaultPassword: '用户的默认密码为123456',
    getDataFail: '获取数据失败',
    createSuccess: '新增成功',
    copySelected: '复制成功',
    updateSuccess: '修改成功',
    deleteSuccess: '删除成功',
    noDataSelected: '请先选择需要操作的数据',
    confirmDelete: '选中数据将被永久删除, 是否继续？',
    confirmDeleteCache: '是否立即清除用户权限缓存？',
    containCurrentUser: '包含当前登录用户，操作已取消',
    neverLogin: '从未登录过系统',
    nothing: '这家伙很懒，什么都没留下',
    topId: '值为0时表示顶级节点',
    choose: '已选择：',
    chooseNothing: '尚未选择任何图标',
    onlyChooseOne: '只能选择一个节点作为父节点',
    noNodeSelected: '请先选择节点',
    confirmDeleteNode: '选中节点及其子结点将被永久删除, 是否继续？',
    iframeGrant: '用户名：wms 密码：wms',
    notEqual: '两次输入不一致',
    oldPasswordIncorrect: '原密码不正确',
    uploadSuccess: '上传成功',
    uploadFailed: '上传失败',
    onlySupportXlsx: '只支持Xlsx类型文件',
    updating: '修改中',
    updateFailed: '修改失败',
    noPermission: '无权限',
    confirmRestPassword: '确定重置所选用户密码？',
    resetPasswordSuccess: '所选用户密码重置已被重置为123456',
    getCodeImageFailed: '获取图形验证码失败',
    tooManyRequest: '获取验证码过于频繁，请1分钟后再试',
    clientOriginSecret: '该客户端原始密码为：',
    publishSuccess: '发布成功',
    confirmPublish: '确定发布流程吗?',
    mappingSuccess: '映射成功'
  },
  rules: {
    require: '不能为空',
    range0to255: '长度在 0 到 255 个字符',
    range2to10: '长度在 2 到 10 个字符',
    range3to10: '长度在 3 到 10 个字符',
    range3to20: '长度在 3 到 20 个字符',
    range4to10: '长度在 4 到 10 个字符',
    range6to20: '长度在 6 到 20 个字符',
    email: '请输入正确的邮箱地址',
    mobile: '请输入合法的手机号',
    usernameExist: '该用户名已存在',
    clientIdExist: '该Client ID已存在',
    roleNameExist: '该角色名称已存在',
    noMoreThan10: '长度不能超过10个字符',
    noMoreThan11: '长度不能超过11个字符',
    noMoreThan20: '长度不能超过20个字符',
    noMoreThan50: '长度不能超过50个字符',
    noMoreThan100: '长度不能超过100个字符',
    invalidInteger: '请输入大于零的整数',
    invalidURL: '不是有效的URL'
  },
  common: {
    system: '嘉善安置场所管理后台',
    desc: {
      a: '基于SpringBoot 2.3.6 & SpringCloud Hoxton.SR9'
    },
    view: '查看',
    tips: '提示',
    clear: '清除',
    confirm: '确定',
    cancel: '取消',
    add: '新增',
    edit: '修改',
    copy: '复制',
    upload: '上传',
    yes: '是',
    no: '否',
    sex: {
      male: '男性',
      female: '女性',
      secret: '保密'
    },
    status: {
      valid: '启用',
      invalid: '禁用'
    },
    state: {
      valid: '启用',
      invalid: '禁用'
    },
    menu: {
      menu: '菜单',
      button: '按钮'
    },
    tab: {
      common: '通用类',
      directivity: '指向性',
      solid: '填充类',
      food: '食品类'
    },
    aboutMe: '关于我',
    changeAvatar: '更换头像',
    lastLoginTime: '上次登录时间',
    goodMorning: '早上好',
    goodAfternoon: '下午好',
    goodEvening: '晚上好',
    randomMessage: {
      0: '帮我帮我帮我帮我帮我帮我帮我',
      1: '喝杯咖啡休息下吧☕',
      2: '要不要和朋友打局LOL',
      3: '今天又写了几个Bug🐞呢',
      4: '今天在群里吹水了吗',
      5: '今天吃了什么好吃的呢',
      6: '今天您微笑了吗😊',
      7: '今天帮别人解决问题了吗',
      8: '准备吃些什么呢',
      9: '周末要不要去看电影？'
    },
    docDetails: '了解更多',
    allProject: '所有项目',
    noEmail: '暂无邮箱',
    noMobile: '暂无手机',
    noDept: '暂无部门',
    noRole: '暂无角色',
    noWorkDescribe: '这家伙很懒，什么也没留下~',
    firstLogin: '第一次登录系统',
    todayIp: '今日IP',
    todayVisit: '今日访问',
    TotalVisit: '总访问量',
    you: '您',
    total: '总数',
    visitTitle: '近十天系统访问记录',
    timeline: '登录时间',
    account: '账号信息',
    password: '个人密码',
    importResult: '导入结果',
    hthz: '后田花子',
    al: '阿里系',
    lm: '脸萌',
    ctc: '点击选择',
    pleaseInputUrl: '请输入URL',
    bind: '绑定',
    unbind: '解绑',
    confirmUnbind: '确定解绑该第三方账号？',
    unbindSuccess: '解绑成功',
    bindSuccess: '绑定成功',
    bindLogin: '绑定并登录',
    signLogin: '注册并登录',
    current: '当前',
    socialAccount: '账号',
    socialTips: '尚未绑定任何系统账户，您可以绑定系统账户或者注册一个新的账户并绑定。'
  }
};
exports.default = _default;